import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=f6dd09ce&scoped=true&"
import script from "./ContentBlock.vue?vue&type=script&lang=js&"
export * from "./ContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlock.vue?vue&type=style&index=0&id=f6dd09ce&lang=scss&scoped=true&"
import style1 from "./ContentBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dd09ce",
  null
  
)

export default component.exports